import { Box, Container, useDisclosure } from "@chakra-ui/react";
import React, { useState } from "react";
import Navbar from "./components/Common/Navbar";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import FeedbackList from "./components/Feedback/FeedbackList";
import FeedbackModal from "./components/Feedback/FeedbackModal";
import useFeedbacks from "./hooks/useFeedbacks";

function App() {
  const [activeSection, setActiveSection] = useState("Home");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { feedbacks, loading, hasMore, fetchFeedbacks, addFeedback } =
    useFeedbacks();

  const sections = ["Home", "About", "Projects", "Contact", "Feedbacks"];

  const renderSection = () => {
    switch (activeSection) {
      case "Home":
        return <Home />;
      case "About":
        return <About />;
      case "Projects":
        return <Projects />;
      case "Contact":
        return <Contact />;
      case "Feedbacks":
        return (
          <FeedbackList
            feedbacks={feedbacks}
            loading={loading}
            hasMore={hasMore}
            fetchMore={fetchFeedbacks}
          />
        );
      default:
        return <Home />;
    }
  };

  return (
    <Box>
      <Navbar
        sections={sections}
        onSelect={setActiveSection}
        onFeedbackClick={onOpen}
      />
      <Container maxW="container.xl" py={10}>
        {renderSection()}
      </Container>
      <FeedbackModal
        isOpen={isOpen}
        onClose={onClose}
        onFeedbackSubmit={addFeedback}
      />
    </Box>
  );
}

export default App;
